import React, { useEffect, useMemo } from 'react';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';

const ProductSelector = ({
    topicMap,       // Object containing topic data
    selectedId,     // Currently selected topic ID
    onSelect,       // Callback when selection changes

    label = "Product",
    className = "",
    size = "small",
    sx = {}
}) => {
    // Memoize valid topics to prevent infinite loops
    const validTopics = useMemo(() => {
        return Object.values(topicMap || {}).filter(item => {
            const isValid = item && item.id && (item.name || item.topic);
            return isValid;
        });
    }, [topicMap]);

    // Memoize sorted items
    const sortedItems = useMemo(() => {
        return [...validTopics].sort((a, b) => {
            const priorityA = a.priority === undefined ? Infinity : a.priority;
            const priorityB = b.priority === undefined ? Infinity : b.priority;
            return priorityA - priorityB;
        });
    }, [validTopics]);

    // Auto-select the first item if nothing is selected and we have valid topics
    useEffect(() => {
        if (!selectedId && sortedItems.length > 0) {
            onSelect(sortedItems[0].id);
        }
    }, [selectedId, sortedItems, onSelect]);
    
    // Don't render until we have actual data
    if (sortedItems.length === 0) {
        return null;
    }

    // Use selectedId if valid, otherwise empty string (useEffect will auto-select)
    const isSelectedIdValid = sortedItems.some(topic => topic.id === selectedId);
    const effectiveSelectedId = isSelectedIdValid ? selectedId : '';

    return (
        <FormControl className={className} size={size} variant="outlined" sx={sx}>
            {label && <InputLabel id="product-select-label">{label}</InputLabel>}
            <Select
                labelId="product-select-label"
                id="product-select"
                value={effectiveSelectedId || ''}
                label={label || undefined}
                onChange={(e) => {
                    console.log("ProductSelector - Selection changed to:", e.target.value);
                    onSelect(e.target.value);
                }}
                sx={{
                    '& .MuiSelect-select': {
                        backgroundColor: 'white',
                        paddingRight: '32px !important'
                    }
                }}
            >
                {sortedItems.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                        {item.name || item.topic}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default ProductSelector; 